export const categories = [
  { slug: "lianai", name: "恋爱", icon: "ri-heart-line", count: 328 },
  { slug: "qihuan", name: "奇幻", icon: "ri-magic-line", count: 256 },
  { slug: "dongzuo", name: "动作", icon: "ri-sword-line", count: 198 },
  { slug: "xuanyi", name: "悬疑", icon: "ri-search-eye-line", count: 175 },
  { slug: "gaoxiao", name: "搞笑", icon: "ri-emotion-laugh-line", count: 210 },
  { slug: "zhiyu", name: "治愈", icon: "ri-heart-pulse-line", count: 142 },
  { slug: "dushi", name: "都市", icon: "ri-building-line", count: 189 },
  { slug: "kongbu", name: "恐怖", icon: "ri-ghost-line", count: 88 },
];

export const comics = [
  {
    id: 1,
    title: "社内相亲",
    author: "HAEBI / NARAK",
    slug: "she-nei-xiang-qin",
    category: "恋爱",
    categorySlug: "lianai",
    status: "连载中",
    cover: "https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20cover%20illustration%20style%2C%20young%20couple%20in%20modern%20office%20setting%2C%20soft%20warm%20lighting%2C%20elegant%20character%20design%2C%20clean%20lineart%2C%20pastel%20color%20palette%2C%20romantic%20atmosphere%2C%20Korean%20webtoon%20art%20style%2C%20professional%20composition&width=600&height=800&seq=comic-001&orientation=portrait",
    latestChapter: "第128话",
    description: "普通上班族申夏莉代替朋友去相亲，意外发现相亲对象竟是自家公司社长。一场充满误会与甜蜜的办公室恋情就此展开。",
    rating: 9.5,
    views: 1280000,
    updatedAt: "2026-07-08",
    featured: true,
    featuredOrder: 1,
  },
  {
    id: 2,
    title: "我独自升级",
    author: "Chugong / DUBU",
    slug: "wo-du-zi-sheng-ji",
    category: "动作",
    categorySlug: "dongzuo",
    status: "已完结",
    cover: "https://readdy.ai/api/search-image?query=Korean%20action%20manhwa%20cover%2C%20powerful%20male%20protagonist%20with%20dark%20aura%2C%20shadow%20army%20behind%20him%2C%20dramatic%20lighting%2C%20intense%20composition%2C%20dark%20and%20moody%20color%20scheme%2C%20Korean%20webtoon%20art%20style%2C%20epic%20fantasy%20atmosphere&width=600&height=800&seq=comic-002&orientation=portrait",
    latestChapter: "第179话（完结）",
    description: "被称为「人类最弱兵器」的成振宇，在一次濒死经历后获得了神秘的「系统」能力，成为唯一能够「升级」的猎人。",
    rating: 9.8,
    views: 2560000,
    updatedAt: "2026-07-06",
    featured: true,
    featuredOrder: 2,
  },
  {
    id: 3,
    title: "女神降临",
    author: "Yaongyi",
    slug: "nv-shen-jiang-lin",
    category: "恋爱",
    categorySlug: "lianai",
    status: "已完结",
    cover: "https://readdy.ai/api/search-image?query=Korean%20romance%20beauty%20manhwa%20cover%2C%20gorgeous%20female%20protagonist%20with%20makeup%2C%20stylish%20fashion%2C%20bright%20cherry%20blossom%20background%2C%20soft%20pastel%20colors%2C%20elegant%20Korean%20webtoon%20art%20style%2C%20romantic%20youth%20atmosphere&width=600&height=800&seq=comic-003&orientation=portrait",
    latestChapter: "第224话（完结）",
    description: "因外貌被欺凌的女孩通过化妆技巧变身为校园女神，在两个性格迥异的男生之间，展开了一段关于自信与爱情的故事。",
    rating: 9.3,
    views: 2100000,
    updatedAt: "2026-07-05",
    featured: true,
    featuredOrder: 3,
  },
  {
    id: 4,
    title: "全知读者视角",
    author: "sing N song / Sleepy-C",
    slug: "quan-zhi-du-zhe-shi-jiao",
    category: "奇幻",
    categorySlug: "qihuan",
    status: "连载中",
    cover: "https://readdy.ai/api/search-image?query=Korean%20fantasy%20manhwa%20cover%2C%20male%20protagonist%20with%20mysterious%20book%2C%20apocalyptic%20cityscape%20background%2C%20dramatic%20lighting%2C%20intricate%20magic%20effects%2C%20Korean%20webtoon%20art%20style%2C%20epic%20adventure%20atmosphere&width=600&height=800&seq=comic-004&orientation=portrait",
    latestChapter: "第212话",
    description: "独读者金独子发现他追了十年的小说变成了现实，凭借对小说的了解，他必须在这个末日世界中生存下去。",
    rating: 9.7,
    views: 1890000,
    updatedAt: "2026-07-08",
    featured: false,
    featuredOrder: 0,
  },
  {
    id: 5,
    title: "甜蜜家园",
    author: "Carnby Kim / Youngchan Hwang",
    slug: "tian-mi-jia-yuan",
    category: "恐怖",
    categorySlug: "kongbu",
    status: "已完结",
    cover: "https://readdy.ai/api/search-image?query=Korean%20horror%20thriller%20manhwa%20cover%2C%20apartment%20building%20with%20monster%20silhouette%2C%20dark%20ominous%20atmosphere%2C%20survival%20theme%2C%20scary%20mood%2C%20Korean%20webtoon%20art%20style%2C%20tense%20suspenseful%20composition&width=600&height=800&seq=comic-005&orientation=portrait",
    latestChapter: "第140话（完结）",
    description: "一场突如其来的灾难将公寓居民困在楼内，人类开始变异成可怕的怪物，幸存者们必须团结起来对抗恐惧。",
    rating: 9.4,
    views: 1650000,
    updatedAt: "2026-07-03",
    featured: false,
    featuredOrder: 0,
  },
  {
    id: 6,
    title: "梨泰院Class",
    author: "Gwang Jin",
    slug: "li-tai-yuan-class",
    category: "都市",
    categorySlug: "dushi",
    status: "已完结",
    cover: "https://readdy.ai/api/search-image?query=Korean%20drama%20manhwa%20cover%2C%20young%20entrepreneur%20in%20Seoul%20street%20restaurant%20setting%2C%20night%20cityscape%20neon%20lights%2C%20determined%20expression%2C%20Korean%20webtoon%20art%20style%2C%20urban%20modern%20atmosphere&width=600&height=800&seq=comic-006&orientation=portrait",
    latestChapter: "第103话（完结）",
    description: "朴世路在经历人生低谷后，在梨泰院开设了自己的餐厅，一步步实现复仇与梦想的励志故事。",
    rating: 9.2,
    views: 1420000,
    updatedAt: "2026-07-01",
    featured: false,
    featuredOrder: 0,
  },
  {
    id: 7,
    title: "她的私生活",
    author: "Kim Sung-yeon",
    slug: "ta-de-si-sheng-huo",
    category: "恋爱",
    categorySlug: "lianai",
    status: "连载中",
    cover: "https://readdy.ai/api/search-image?query=Korean%20romance%20comedy%20manhwa%20cover%2C%20female%20protagonist%20dual%20life%20concept%2C%20art%20gallery%20curator%20and%20fangirl%2C%20bright%20colorful%20composition%2C%20playful%20mood%2C%20Korean%20webtoon%20art%20style%2C%20youthful%20vibrant%20atmosphere&width=600&height=800&seq=comic-007&orientation=portrait",
    latestChapter: "第96话",
    description: "美术馆策展人成德美隐藏着自己的追星族身份，与新任馆长展开了一段充满误会与甜蜜的办公室恋情。",
    rating: 9.1,
    views: 980000,
    updatedAt: "2026-07-07",
    featured: false,
    featuredOrder: 0,
  },
  {
    id: 8,
    title: "惊奇的传闻",
    author: "Jang Yi",
    slug: "jing-qi-de-chuan-wen",
    category: "悬疑",
    categorySlug: "xuanyi",
    status: "连载中",
    cover: "https://readdy.ai/api/search-image?query=Korean%20mystery%20supernatural%20manhwa%20cover%2C%20noodle%20shop%20demon%20hunters%2C%20action%20scene%20with%20supernatural%20elements%2C%20dramatic%20composition%2C%20Korean%20webtoon%20art%20style%2C%20thrilling%20dark%20atmosphere&width=600&height=800&seq=comic-008&orientation=portrait",
    latestChapter: "第185话",
    description: "一家看似普通的面馆，实际上是捉鬼猎人组织的秘密基地，他们白天卖面、夜晚驱魔。",
    rating: 9.0,
    views: 1120000,
    updatedAt: "2026-07-08",
    featured: false,
    featuredOrder: 0,
  },
  {
    id: 9,
    title: "柔美的细胞君",
    author: "Lee Dong-gun",
    slug: "rou-mei-de-xi-bao-jun",
    category: "治愈",
    categorySlug: "zhiyu",
    status: "已完结",
    cover: "https://readdy.ai/api/search-image?query=Korean%20slice%20of%20life%20healing%20manhwa%20cover%2C%20cute%20cell%20characters%20with%20female%20protagonist%2C%20warm%20cozy%20colors%2C%20charming%20illustration%2C%20Korean%20webtoon%20art%20style%2C%20heartwarming%20daily%20life%20atmosphere&width=600&height=800&seq=comic-009&orientation=portrait",
    latestChapter: "第320话（完结）",
    description: "通过女孩柔美体内的细胞们来讲述她的日常生活与感情故事，每个细胞都有独特的性格，温暖而治愈。",
    rating: 9.6,
    views: 1780000,
    updatedAt: "2026-06-28",
    featured: false,
    featuredOrder: 0,
  },
  {
    id: 10,
    title: "便利店新星",
    author: "Hwal Hwa San",
    slug: "bian-li-dian-xin-xing",
    category: "搞笑",
    categorySlug: "gaoxiao",
    status: "已完结",
    cover: "https://readdy.ai/api/search-image?query=Korean%20comedy%20manhwa%20cover%2C%20convenience%20store%20setting%20with%20quirky%20characters%2C%20bright%20funny%20composition%2C%20vibrant%20colors%2C%20Korean%20webtoon%20art%20style%2C%20humorous%20playful%20atmosphere&width=600&height=800&seq=comic-010&orientation=portrait",
    latestChapter: "第78话（完结）",
    description: "正直的便利店店长与不靠谱的兼职生之间发生的各种爆笑日常，一部轻松愉快的职场喜剧。",
    rating: 8.9,
    views: 890000,
    updatedAt: "2026-06-25",
    featured: false,
    featuredOrder: 0,
  },
  {
    id: 11,
    title: "恶之花",
    author: "Jung Seo",
    slug: "e-zhi-hua",
    category: "悬疑",
    categorySlug: "xuanyi",
    status: "连载中",
    cover: "https://readdy.ai/api/search-image?query=Korean%20mystery%20psychological%20thriller%20manhwa%20cover%2C%20dark%20floral%20motif%20with%20hidden%20secrets%2C%20suspenseful%20mood%2C%20mysterious%20atmosphere%2C%20Korean%20webtoon%20art%20style%2C%20elegant%20yet%20ominous%20composition&width=600&height=800&seq=comic-011&orientation=portrait",
    latestChapter: "第67话",
    description: "一个看似完美的家庭背后隐藏着不可告人的秘密，随着真相一层层被揭开，每个人的面具都开始碎裂。",
    rating: 9.3,
    views: 1050000,
    updatedAt: "2026-07-06",
    featured: false,
    featuredOrder: 0,
  },
  {
    id: 12,
    title: "非常校护档案",
    author: "Jung Yeon",
    slug: "fei-chang-xiao-hu-dang-an",
    category: "奇幻",
    categorySlug: "qihuan",
    status: "已完结",
    cover: "https://readdy.ai/api/search-image?query=Korean%20fantasy%20school%20manhwa%20cover%2C%20school%20nurse%20with%20magical%20abilities%2C%20colorful%20jelly%20monsters%2C%20whimsical%20atmosphere%2C%20Korean%20webtoon%20art%20style%2C%20imaginative%20vibrant%20composition&width=600&height=800&seq=comic-012&orientation=portrait",
    latestChapter: "第52话（完结）",
    description: "拥有特殊能力的校护安恩英，在一所神秘的高中里驱除各种奇异的「果冻怪物」，守护学生们的安全。",
    rating: 8.8,
    views: 720000,
    updatedAt: "2026-06-20",
    featured: false,
    featuredOrder: 0,
  },
];

export const testimonials = [
  {
    id: 1,
    name: "小雨",
    role: "资深韩漫读者",
    avatar: "https://readdy.ai/api/search-image?query=Korean%20young%20woman%20portrait%20profile%2C%20soft%20natural%20lighting%2C%20simple%20clean%20background%2C%20warm%20tone%2C%20friendly%20expression&width=120&height=120&seq=avatar-01&orientation=squarish",
    comment: "这个网站真的太棒了！更新速度超快，资源也很全。我最喜欢下拉式的阅读方式，翻页特别流畅，看漫画完全不卡顿。",
    rating: 5,
  },
  {
    id: 2,
    name: "阿杰",
    role: "漫画博主",
    avatar: "https://readdy.ai/api/search-image?query=Korean%20young%20man%20portrait%20profile%2C%20casual%20stylish%20look%2C%20simple%20clean%20background%2C%20warm%20tone%2C%20confident%20expression&width=120&height=120&seq=avatar-02&orientation=squarish",
    comment: "作为漫画博主，我每天都在这里找素材。分类很清晰，找漫画特别方便。强烈推荐给所有韩漫爱好者！",
    rating: 5,
  },
  {
    id: 3,
    name: "小美",
    role: "大学生",
    avatar: "https://readdy.ai/api/search-image?query=Korean%20young%20woman%20portrait%20profile%2C%20bright%20smile%2C%20simple%20clean%20background%2C%20warm%20tone%2C%20cheerful%20expression&width=120&height=120&seq=avatar-03&orientation=squarish",
    comment: "自从发现了这个网站，每天睡前都要看一会儿韩漫。画质高清、翻译质量也很好，关键是完全免费！",
    rating: 5,
  },
  {
    id: 4,
    name: "老王",
    role: "上班族",
    avatar: "https://readdy.ai/api/search-image?query=Korean%20middle%20aged%20man%20portrait%20profile%2C%20professional%20look%2C%20simple%20clean%20background%2C%20warm%20tone%2C%20relaxed%20expression&width=120&height=120&seq=avatar-04&orientation=squarish",
    comment: "通勤路上必看！下拉式阅读单手操作超方便，地铁上也能轻松追漫。内容更新及时，追番体验一流。",
    rating: 5,
  },
  {
    id: 5,
    name: "莉莉",
    role: "自由职业者",
    avatar: "https://readdy.ai/api/search-image?query=Korean%20young%20woman%20portrait%20profile%2C%20artistic%20vibe%2C%20simple%20clean%20background%2C%20warm%20tone%2C%20gentle%20smile&width=120&height=120&seq=avatar-05&orientation=squarish",
    comment: "画面精美，阅读体验超赞。最惊喜的是恐怖类韩漫资源很全，平时很难找到的冷门作品这里都有。",
    rating: 4,
  },
];

export const faqs = [
  {
    question: "这个网站收费吗？",
    answer: "完全免费！韩漫头条致力于为韩漫爱好者提供免费的阅读平台，所有漫画均可免费阅读，无需任何付费。",
  },
  {
    question: "漫画更新频率如何？",
    answer: "我们的团队每天更新，保持与原版同步的更新频率。热门连载漫画通常在原版更新后24小时内完成翻译并上线。",
  },
  {
    question: "支持哪些阅读方式？",
    answer: "我们采用下拉式阅读模式，无需翻页，一键下滑即可流畅阅读。同时支持PC端和移动端，在任何设备上都能获得良好的阅读体验。",
  },
  {
    question: "漫画是高清画质吗？",
    answer: "是的，所有漫画均采用高清画质呈现，确保读者能够享受到最清晰细腻的画面细节，不遗漏任何精彩画面。",
  },
  {
    question: "找不到想看的漫画怎么办？",
    answer: "您可以通过搜索功能查找，或浏览我们的分类页面。如果仍然找不到，欢迎通过联系表单向我们反馈，我们会尽快考虑收录。",
  },
  {
    question: "支持离线下载吗？",
    answer: "目前我们仅支持在线阅读。为了提供最佳体验和保证内容更新及时，建议您在网络环境下阅读。离线功能正在规划中。",
  },
];